import {
    formatContentTime,
    formatDatetimeToISO,
} from "../../utils/datetime/LightweightDateTimeUtils";
import React from "react";
import PropTypes from "prop-types";
import GTMTracker from "../../utils/tracking/GTMTracker";
import Navigation from "../../utils/Navigation";

export default class VideoMetadata extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            isSummaryShown: false,
        };

        this._onClick = this._onClick.bind(this);
    }

    render() {
        const { isSummaryShown } = this.state;
        const additionalFooterClass = isSummaryShown
            ? "video-metadata--shown"
            : "";
        const publishedAt = new Date(this.props.publishedAt);
        const isoPublishedAtDateTime = formatDatetimeToISO(publishedAt);
        const { series, linkToSeriesPageEnabled, formattedPublishedAt } =
            this.props;
        const displayDate =
            formattedPublishedAt || formatContentTime(publishedAt);
        const seriesInfo = renderSeries(series, linkToSeriesPageEnabled);
        return (
            <div
                className={`video-metadata ${additionalFooterClass}`}
                onClick={this._onClick}
            >
                <div className="video-metadata__info">
                    <h1
                        className="video-metadata__title"
                        dangerouslySetInnerHTML={this._getHeadline()}
                    />
                    <div className="video-metadata__footer">
                        {seriesInfo}
                        <time
                            className="video-metadata__publishtime"
                            dateTime={isoPublishedAtDateTime}
                        >
                            {displayDate}
                        </time>
                    </div>
                    <p
                        className="video-metadata__summary"
                        dangerouslySetInnerHTML={this._getSummary()}
                    />
                </div>
            </div>
        );
    }

    _onClick() {
        this.setState({ isSummaryShown: !this.state.isSummaryShown });
    }

    _getHeadline() {
        return { __html: this.props.headlineHtml };
    }

    _getSummary() {
        return { __html: this.props.summaryHtml };
    }
}

function renderSeries(series, linkToSeriesPageEnabled) {
    if (!series) {
        return null;
    }

    const formattedSeries = series.reduce((result, element) => {
        if (!element || !element.name) {
            return result;
        }

        const { id: elementId, name: elementName } = element;
        const formattedElement = linkToSeriesPageEnabled ? (
            <a
                className="video-metadata__seriesname-link"
                href={`/btv/series/${elementId}`}
                onClick={onSelectSeries.bind(null, elementId)}
            >
                {elementName}
            </a>
        ) : (
            elementName
        );
        result.push(
            <li key={elementId} className="video-metadata__seriesname">
                <h2 className="video-metadata__seriesname-header">
                    {formattedElement}
                </h2>
            </li>
        );
        return result;
    }, []);

    return formattedSeries.length > 0 ? (
        <ul className="video-metadata__seriesname-container">
            {formattedSeries}
        </ul>
    ) : null;
}

function onSelectSeries(elementId, event) {
    GTMTracker.trackRecirc({
        bvpEventAction: "click",
        bvpEventLabel: `video.show.${elementId}`,
    });
    Navigation.delayNavigateTo(event);
}

VideoMetadata.defaultProps = {
    summaryHtml: "",
    linkToSeriesPageEnabled: false,
};

VideoMetadata.propTypes = {
    publishedAt: PropTypes.string.isRequired,
    headlineHtml: PropTypes.string.isRequired,
    summaryHtml: PropTypes.string.isRequired,
    formattedPublishedAt: PropTypes.string,
    linkToSeriesPageEnabled: PropTypes.bool,
    series: PropTypes.arrayOf(PropTypes.object),
};
